<template>
  <v-container>
    <v-layout wrap>
      <v-flex xs12>
        <h1 class="display-1 mb-5">Supervision</h1>

        <v-layout>
          <v-flex xs6>
            FOURS
            <pre v-for="oven in ovenList" v-bind:key="oven.id">{{ oven }}</pre>
          </v-flex>
          <v-flex xs6>
            CLIENT
            <pre v-for="client in clientList" v-bind:key="client.id">{{ client }}</pre>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
import config from "../config";

const NAMESPACE_OVEN = "/ws_admin";

export default {
  data: () => ({
    ovenList: [],
    clientList: []
  }),
  methods: {
    // chargement de la liste des fours connectés
    loadOvenList() {
      this.api
        .get("/admin/live/ovens")
        .then(res => {
          this.ovenList = res.data;
        })
        .catch(err => {
          console.error(err);
        });
    },
    // chargement de la liste des clients connectés
    loadClientList() {
      this.api
        .get("/admin/live/clients")
        .then(res => {
          this.clientList = res.data;
        })
        .catch(err => {
          console.error(err);
        });
    }
  },
  mounted() {
    this.loadOvenList();
    this.loadClientList();
  }
};
</script>


<style>
</style>
